/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalReauthSubmissionRequest
 */
export interface CreatePalReauthSubmissionRequest {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    pal_submission_id: string;
    /**
     * 
     */
    next_review_date: string;
    /**
     * 
     */
    external_id?: string | null;
    /**
     * 
     */
    level?: string | null;
}

/**
 * Check if a given object implements the CreatePalReauthSubmissionRequest interface.
 */
export function instanceOfCreatePalReauthSubmissionRequest(value: object): value is CreatePalReauthSubmissionRequest {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('pal_submission_id' in value) || value['pal_submission_id'] === undefined) return false;
    if (!('next_review_date' in value) || value['next_review_date'] === undefined) return false;
    return true;
}

export function CreatePalReauthSubmissionRequestFromJSON(json: any): CreatePalReauthSubmissionRequest {
    return CreatePalReauthSubmissionRequestFromJSONTyped(json, false);
}

export function CreatePalReauthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'next_review_date': json['next_review_date'],
        'external_id': json['external_id'] === undefined ? undefined : json['external_id'] === null ? null : json['external_id'],
        'level': json['level'] === undefined ? undefined : json['level'] === null ? null : json['level'],
    };
}

export function CreatePalReauthSubmissionRequestToJSON(json: any): CreatePalReauthSubmissionRequest {
    return CreatePalReauthSubmissionRequestToJSONTyped(json, false);
}

export function CreatePalReauthSubmissionRequestToJSONTyped(value?: CreatePalReauthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'pal_submission_id': value['pal_submission_id'],
        'next_review_date': value['next_review_date'],
        'external_id': value['external_id'],
        'level': value['level'],
    };
}

